export default __webpack_public_path__ + "static/media/R.788c2b70.png";